// DS6.9.1
import React, { useMemo, useContext } from 'react';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import CustomNotificationProvider from '../../Notifications/CustomNotificationContext';
import PopoverNotification from '../../Notifications/PopoverNotification';
import { NotificationType } from '../../Notifications';
import { ScreenSizeContext } from '../../Measured';
import Badge from '@wix/da-ds/pkg/Badge';
import CoreBadgeButton from '../CoreBadgeButton';
import { badgeNotificationsFilter } from '../utils';
import s from './CoreBadgeList.scss';
var STACKED_BADGES_THRESHOLD = 2;
var CoreBadgeList = function (_a) {
    var badges = _a.badges, recipient = _a.recipient, notificationQueueName = _a.notificationQueueName, biData = _a.biData, className = _a.className, _b = _a.size, size = _b === void 0 ? 'large' : _b;
    var isMobile = useContext(MobileContext);
    var screenWidth = useContext(ScreenSizeContext).width;
    // tally up the total of badges awarded
    var badgeCount = useMemo(function () { return badges.reduce(function (prev, curr) { var _a; return prev + ((_a = curr.stackCount) !== null && _a !== void 0 ? _a : 0); }, 0); }, [badges]);
    if (badges.length < 1) {
        return null;
    }
    // only last four badges
    var visibleBadges = badges.slice(-4);
    // if over 1000 badges, represent as 1k
    var totalBadges = badgeCount > 999 ? "".concat(Math.floor(badgeCount / 1000), "k") : badgeCount;
    // if "stacked" it means the badges will be displayed in an overlapped manner
    var isStacked = visibleBadges.length > STACKED_BADGES_THRESHOLD;
    return (React.createElement(CustomNotificationProvider, { queueName: notificationQueueName },
        React.createElement(Section, { className: cn(s['root'], s["size-".concat(size)], isStacked && s['stacked'], className) },
            React.createElement(VisuallyHidden, null,
                React.createElement(Heading, null, "Badge Awards")),
            visibleBadges.map(function (badge, idx) {
                return badge.stackCount && (React.createElement(PopoverNotification, { key: "CoreBadgeList-".concat(idx), placement: isMobile || screenWidth <= 1250 ? 'top' : undefined, secondaryPlacement: isMobile || screenWidth <= 1250 ? 'end' : undefined, className: cn(s['button'], idx === 0 && s['button-first']), contentClassName: s['notification'], notificationTypes: [NotificationType.Badge], notificationFilter: badgeNotificationsFilter(badge.name) },
                    React.createElement(CoreBadgeButton, { key: badge.name, type: badge.name, badges: badges, recipient: recipient, biData: biData, hideTooltip: true },
                        React.createElement(Badge, { badge: badge, className: s['badge'], size: size === 'large' ? 24 : 16 }))));
            }),
            totalBadges && React.createElement("div", { className: s['badge-count'] }, totalBadges))));
};
CoreBadgeList.displayName = 'CoreBadgeList';
export default CoreBadgeList;
//# sourceMappingURL=CoreBadgeList.js.map